import { render, staticRenderFns } from "./OfertaList.vue?vue&type=template&id=5e66f952&scoped=true&"
import script from "./OfertaList.vue?vue&type=script&lang=js&"
export * from "./OfertaList.vue?vue&type=script&lang=js&"
import style0 from "./OfertaList.vue?vue&type=style&index=0&id=5e66f952&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e66f952",
  null
  
)

export default component.exports